/**
 * @Author : zhouqinze
 * @Date : 2019-12-27
 * @Version : 1.0
 * @Content : 首页
 **/
<template>
    <div>
        <Banner />
        <HomeContent />
    </div>
</template>

<script>
import Banner from '../components/Banner.vue'
import HomeContent from '../components/HomeContent.vue'
export default {
    components:{
        Banner,
        HomeContent,
    }
}
</script>